import React from 'react';

const ClubItem = ({ image, title, subtitle, subtitle2, address, url, facebook, instagram, whatsapp, children }) =>
	<article className="box">
		<div className="columns">
			<div className="column is-half">
				<img src={image}/>
			</div>
			<div className="column is-half">
				<div className="media">
					<div className="media-content">
						<div className="content">
							<h1 className="title is-spaced is-marginless">{title}</h1>
							<h2 className="subtitle is-spaced is-marginless">{subtitle}</h2>
							<h2 className="subtitle is-spaced is-marginless">{subtitle2}</h2>
							<a href={url}>{address}</a>
						</div>
						<div className="content">
							{children}
						</div>
						<div className="content">
							{facebook && <a href={facebook}>
								<span className="icon is-small">
									<i className="fa fa-facebook"></i>
								</span>
								<span> </span>
								Facebook
							</a>}
							{facebook && <span className="icon is-small"></span>}
							{instagram && <a href={instagram}>
								<span className="icon is-small">
									<i className="fa fa-instagram"></i>
								</span>
								<span> </span>
								Instagram
							</a>}
							{instagram && <span className="icon is-small"></span>}
							{whatsapp && <a href={whatsapp}>
								<span className="icon is-small">
									<i className="fa fa-whatsapp"></i>
								</span>
								<span> </span>
								WhatsApp
							</a>}
						</div>
					</div>
				</div>
			</div>
		</div>
	</article>

export default ClubItem;



// WEBPACK FOOTER //
// ./src/components/Info/ClubItem.js